module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-yellow.1242565.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-yellow.svg
// module id = gnwi
// module chunks = 74